import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataCollection } from '../../models/site-content/data-collection.model';
import { DataCollectionStatus } from '../../models/data-collection-status.model';
import { AccessibilityHelper } from '../../accessibility.helper';

@Component({
    selector: 'app-site-details',
    templateUrl: './site-details.component.html',
    styleUrls: ['./site-details.component.scss'],
    standalone: false
})
export class SiteDetailsComponent implements OnInit {

    @Input() site: DataCollection;
    @Input() closable: boolean = false;

    @Output() onEdit: EventEmitter<string> = new EventEmitter();
    @Output() close: EventEmitter<string> = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    onEditClick(evt: any): void {
        if (this.site.siteIsBuildable) {
            AccessibilityHelper.preventDoubleHitOnEvent(evt);
            this.onEdit.emit('details');
        }
    }

    onClose(): void {
        this.close.emit();
    }

    showClosedDate(): boolean {
        return this.site.closedDate && this.site.closedDate > this.site.activatedDate;
    }

    showActivatedDate(): boolean {
        return this.site.activatedDate != null && this.site.currentStatus !== DataCollectionStatus.SETUP;
    }
}
